import React from 'react';
import { Text } from '@instructure/ui-text';
var REQUIRED_SYMBOL = ' *';

/**
 * Update the label to include a required start(*) at the end.
 *
 * @param {import('@instructure/shared-types').Renderable} label - The label to enhance
 * @param {boolean | undefined} isRequired - Whether the field is required
 * @param {boolean | undefined} isError - Whether the field has validation erros
 * @returns {import('@instructure/ui-form-field').Renderable} The enhanced label
 */
export function enhanceLabel(label, isRequired, isError) {
  var _label$type;
  if (!label || ((_label$type = label.type) === null || _label$type === void 0 ? void 0 : _label$type.displayName) === 'ScreenReaderContent') {
    return label;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, null, label), isRequired && /*#__PURE__*/React.createElement(Text, {
    color: isError ? 'danger' : 'primary',
    "aria-hidden": "true"
  }, REQUIRED_SYMBOL));
}

/**
 * Check if the messages contain an error
 *
 * @param {import('@instructure/ui-form-field').FormMessage[] | undefined} messages - Whether the field is required
 * @returns {boolean} Whether the messages contain an error
 */
export function hasErrorMessage(messages) {
  return messages === null || messages === void 0 ? void 0 : messages.some(function (message) {
    return message.type === 'error';
  });
}